import React from 'react';
import Sidebar from './Sidebar';
import TopNavigation from './TopNavigation';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[var(--clr-surface-subtle)]">
      <Sidebar />
      
      {/* Main content area */}
      <div className="lg:ml-64 transition-all duration-300">
        <TopNavigation />
        <main className="p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
